import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
     Container, Row, Col,
     Label, Input, InputGroup, CardLink,
     Card, CardImg, CardText, CardBody,
     CardTitle, CardSubtitle, Button, Badge,
     FormFeedback, Modal, ModalHeader, ModalBody, ModalFooter,
     UncontrolledTooltip,
} from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../api";

import ArticulosModal from './ArticulosModal.js';
import ArticulosDestacadosModalTable from './ArticulosDestacadosModalTable.js';


class DestacadosModal extends Component {
     constructor(props) {
          super(props);
          this.state = {
               nombre: "",
               titulo: "",
               articulos:[],

               postVariables: ['titulo', 'nombre','articulos'],
               errors: [],
          };
     }

     static propTypes = {
          onSubmit: PropTypes.func,
          id: PropTypes.func,
          action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
     }

     resetForm() {
          this.setState({
               titulo: "",
               nombre: "",
               articulos:[],
               errors: [],
          });
     }

     getData() {
          const { postVariables } = this.state;
          let data = {};
          postVariables.forEach(x => {
               data[x] = this.state[x];
          });
          return data;
     }

     setData(data) {
          if (data.success) {
               this.setState({
                    titulo: data.Titulo,
                    nombre: data.Nombre,
                    articulos: data.Articulos ? data.Articulos : [],
               })
          }
     }

     setErrors(errors) {
          this.setState({
               errors: errors,
          });
     }

     onChangeField(field, value) {
          this.setState(prevState => {
               let errors = prevState.errors;
               if (errors) errors[field] = null;
               prevState.errors = errors;
               prevState[field] = value;
               return prevState;
          });
     }

     getError(field) {
          let errors = this.state.errors;
          if (errors) return errors[field];
          else return null;
     }

     modalVars() {
          const { action } = this.props;
          if (action == "CREATE") {
               return {
                    get: false,
                    submitType: "POST",
                    title: "Nueva Presentación de Destacados",
                    buttonTitle: "Nuevo",
                    danger: false,
                    saveButtonLabel: "Guardar",
                    buttonIcon: "fa fa-plus fa-lg",
                    successMessage: "La Presentación de Destacados ha sido creada con éxito.",
                    saveButton: true,
                    buttonClass: "",
                    disabled: false,
               };
          } else if (action == "EDIT") {
               return {
                    get: true,
                    submitType: "PATCH",
                    title: "Editar Presentación de Destacados",
                    buttonTitle: "Editar",
                    saveButtonLabel: "Guardar",
                    danger: false,
                    buttonIcon: "fa fa-pencil fa-lg",
                    successMessage: "La Presentación de Destacados ha sido editada con éxito.",
                    saveButton: true,
                    buttonClass: "",
                    disabled: false,
                    id: this.props.id,
               };
          } else if (action == "DETAIL") {
               return {
                    get: true,
                    submitType: null,
                    title: "Presentación de Destacados",
                    buttonTitle: "Ver",
                    danger: false,
                    buttonIcon: "fa fa-search fa-lg",
                    successMessage: "",
                    saveButton: false,
                    buttonClass: "",
                    disabled: true,
                    id: this.props.id,
               };
          } else if (action == "DELETE") {
               return {
                    get: true,
                    submitType: "DELETE",
                    title: "Eliminar Presentación de Destacados",
                    buttonTitle: "Eliminar",
                    danger: true,
                    saveButtonLabel: "Eliminar",
                    buttonIcon: "fa fa-trash fa-lg",
                    successMessage: "La Presentación de Destacados ha sido eliminada con éxito.",
                    saveButton: true,
                    buttonClass: "btn-danger",
                    disabled: true,
                    id: this.props.id,
               };
          }
     }

     render() {
          let vars = this.modalVars();
          const { action } = this.props;

          return (
               <ParadigmaModal
               getUrl={(vars.get ? api.gestion.articulos.destacados.destacados : null)}
               submitUrl={(vars.submitType ? api.gestion.articulos.destacados.destacados : null)}
               submitType={vars.submitType}
               id={vars.id}
               className={action != "DELETE" ? "modal-xl" : "modal-lg"}
               onGotData={(data) => this.setData(data)}
               onGotErrors={(errors) => this.setErrors(errors)}
               onSubmit={(e) => this.props.onSubmit(e)}
               onClose={() => this.resetForm()}
               onPreSubmit={() => this.getData()}

               title={vars.title}

               danger={vars.danger}
               buttonClass={vars.buttonClass}

               successMessage={vars.successMessage}
               missingIdMessage={"Debe seleccionar una fila."}

               buttonTitle={vars.buttonTitle}
               buttonIcon={vars.buttonIcon}
               saveButton={vars.saveButton}
               saveButtonLabel={vars.saveButtonLabel}
               closeButton={true}
               >
               <ParadigmaLabeledInput
               disabled={vars.disabled}
               md={[2, 10]}
               label={"Descripción"}
               value={this.state.nombre}
               onChange={(e) => this.onChangeField('nombre', e.target.value)}
               error={() => this.getError('nombre')}
               />
               <ParadigmaLabeledInput
               disabled={vars.disabled}
               md={[2, 10]}
               label={"Titulo en Web"}
               value={this.state.titulo}
               onChange={(e) => this.onChangeField('titulo', e.target.value)}
               error={() => this.getError('titulo')}
               />
               {
                    action != "DELETE" &&
                    <Row>
                    <Col className="mt-2">
                    <ArticulosModal
                    vars={vars}
                    articulos={this.state.articulos}
                    onChangeField={(...data)=>this.onChangeField(...data)}
                    />
                    </Col>
                    </Row>
               }
               </ParadigmaModal>
          );
     }
}

export default DestacadosModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Destacados/Modal.js